/**
 * Jouw Mirror Card: interactieve keuzehulp.
 * Prototype: vraagdata, beslislogica en resultaatteksten leven hier in JS.
 * Geen dataopslag (Metaobjects/Sheet) in deze versie, dat volgt na
 * goedkeuring van deze UI/UX (zie blueprint, punt 21-23).
 *
 * Getest en pixel-geverifieerd scenario:
 * Lash & Brow Artist, meer boekingen, na een behandeling/afspraak, 20-40
 * klanten per week, direct opnieuw boeken -> The QR Card, QR naar
 * boekingspagina, 250 stuks.
 */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-mirror-finder]');
  if (!root) return;

  /* ---------------------------------------------------------------------
   * Data: producten, varianten (handles + variant-id's uit de live catalogus)
   * ------------------------------------------------------------------- */
  var PRODUCTS = {
    business: {
      handle: 'the-business-card',
      name: 'THE BUSINESS CARD',
      variants: { 100: '63386194739530', 250: '63386433782090', 500: '63386433814858' },
      launched: true,
      ctaLaunched: 'MAAK JOUW BUSINESS CARDS',
      ctaPrelaunch: 'BEKIJK THE BUSINESS CARD'
    },
    qr: {
      handle: 'the-qr-card',
      name: 'THE QR CARD',
      variants: { 100: '63386195067210', 250: '63386434437450', 500: '63386434470218' },
      launched: true,
      ctaLaunched: 'MAAK JOUW QR CARDS',
      ctaPrelaunch: 'BEKIJK THE QR CARD'
    },
    gift: {
      handle: 'the-gift-card',
      name: 'THE GIFT CARD',
      variants: { 100: '63386195263818', 250: '63386435584330', 500: '63386435617098' },
      launched: true,
      ctaLaunched: 'MAAK JOUW GIFT CARDS',
      ctaPrelaunch: 'BEKIJK THE GIFT CARD'
    },
    loyalty: {
      handle: 'the-loyalty-card',
      name: 'THE LOYALTY CARD',
      variants: { 100: '63386195525962', 250: '63386435649866', 500: '63386435682634' },
      launched: false,
      ctaLaunched: 'MAAK JOUW LOYALTY CARDS',
      ctaPrelaunch: 'BLIJF OP DE HOOGTE'
    }
  };

  /* ---------------------------------------------------------------------
   * Data: de vijf vragen
   * ------------------------------------------------------------------- */
  var QUESTIONS = [
    {
      id: 'industry',
      eyebrow: 'VRAAG 01 / 05',
      title: 'WAT VOOR BUSINESS HEB JE?',
      support: 'Zo kunnen we het advies beter laten aansluiten op jouw klanten en manier van werken.',
      allowOther: true,
      options: [
        { value: 'beauty_salon', label: 'Schoonheidssalon / Huidverbetering' },
        { value: 'lash_brow', label: 'Lash & Brow Artist' },
        { value: 'nails', label: 'Nagelstyliste' },
        { value: 'makeup', label: 'Make-up Artist' },
        { value: 'hair', label: 'Kapper / Hair Artist' },
        { value: 'aesthetics', label: 'Botox & Fillers / Aesthetic Clinic' },
        { value: 'tattoo', label: 'Tattoo Artist / Piercer' },
        { value: 'dental_beauty', label: 'Tanden bleken / Dental Beauty' },
        { value: 'pmu', label: 'PMU Artist' },
        { value: 'photographer', label: 'Fotograaf' },
        { value: 'boutique', label: 'Fashion / Boutique' },
        { value: 'bridal', label: 'Bridal' },
        { value: 'wellness', label: 'Wellness / Spa' },
        { value: 'other', label: 'Anders' }
      ]
    },
    {
      id: 'goal',
      eyebrow: 'VRAAG 02 / 05',
      title: 'WAT WIL JE VOORAL BEREIKEN MET JE MIRROR CARDS?',
      support: 'Kies wat voor jouw business op dit moment het belangrijkste is.',
      options: [
        { value: 'share_contact', label: 'Mijn contactgegevens meegeven' },
        { value: 'more_bookings', label: 'Meer afspraken / boekingen' },
        { value: 'more_instagram', label: 'Meer Instagram-volgers' },
        { value: 'more_reviews', label: 'Meer Google-reviews' },
        { value: 'present_giftcards', label: 'Cadeaubonnen mooier presenteren' },
        { value: 'repeat_customers', label: 'Klanten vaker laten terugkomen' },
        { value: 'luxury_brand', label: 'Mijn merk luxer laten overkomen' },
        { value: 'leave_memorable_impression', label: 'Iets meegeven dat klanten onthouden' }
      ]
    },
    {
      id: 'usage',
      eyebrow: 'VRAAG 03 / 05',
      title: 'WANNEER WIL JE DE CARDS VOORAL GEBRUIKEN?',
      options: [
        { value: 'after_appointment', label: 'Na een behandeling / afspraak' },
        { value: 'new_customers', label: 'Vooral voor nieuwe klanten' },
        { value: 'networking_events', label: 'Tijdens netwerken & events' },
        { value: 'orders_packages', label: 'Bij bestellingen / pakketjes' },
        { value: 'gift', label: 'Als cadeaubon' },
        { value: 'campaigns', label: 'Bij acties of campagnes' },
        { value: 'counter', label: 'Op mijn balie / werkplek' },
        { value: 'various_moments', label: 'Op verschillende momenten' }
      ]
    },
    {
      id: 'volume',
      eyebrow: 'VRAAG 04 / 05',
      title: 'HOEVEEL KLANTEN HEB JE GEMIDDELD PER WEEK?',
      support: 'Hiermee kunnen we een passend startaantal adviseren.',
      options: [
        { value: 'under_10', label: 'Minder dan 10' },
        { value: '10_20', label: '10 – 20' },
        { value: '20_40', label: '20 – 40' },
        { value: '40_75', label: '40 – 75' },
        { value: '75_plus', label: '75+' },
        { value: 'variable', label: 'Dat wisselt sterk / ik weet het niet' }
      ]
    },
    {
      id: 'action',
      eyebrow: 'VRAAG 05 / 05',
      title: 'WAT WIL JE DAT JE KLANT DOET NADAT ZE DE CARD KRIJGT?',
      options: [
        { value: 'keep_contact', label: 'Mijn contactgegevens bewaren' },
        { value: 'book_again', label: 'Direct een nieuwe afspraak boeken' },
        { value: 'follow_instagram', label: 'Mijn Instagram bekijken / volgen' },
        { value: 'leave_review', label: 'Een Google-review achterlaten' },
        { value: 'visit_website_shop', label: 'Mijn website of webshop bezoeken' },
        { value: 'use_as_gift', label: 'De card gebruiken als cadeaubon' },
        { value: 'collect_stamps', label: 'Stempels / punten verzamelen' },
        { value: 'remember_brand', label: 'Vooral mijn merk onthouden' }
      ]
    }
  ];

  /* ---------------------------------------------------------------------
   * Beslislogica
   * ------------------------------------------------------------------- */
  var ACTION_MAP = {
    keep_contact: { product: 'business' },
    book_again: { product: 'qr', qruse: 'booking' },
    follow_instagram: { product: 'qr', qruse: 'instagram' },
    leave_review: { product: 'qr', qruse: 'reviews' },
    visit_website_shop: { product: 'qr', qruse: null },
    use_as_gift: { product: 'gift' },
    collect_stamps: { product: 'loyalty' },
    remember_brand: { product: 'business' }
  };

  var GOAL_MAP = {
    share_contact: { product: 'business' },
    more_bookings: { product: 'qr', qruse: 'booking' },
    more_instagram: { product: 'qr', qruse: 'instagram' },
    more_reviews: { product: 'qr', qruse: 'reviews' },
    present_giftcards: { product: 'gift' },
    repeat_customers: { product: 'loyalty' },
    luxury_brand: { product: 'business' },
    leave_memorable_impression: { product: 'business' }
  };

  var SHOP_INDUSTRIES = ['boutique', 'bridal'];
  var HIGH_USAGE = ['after_appointment', 'orders_packages', 'various_moments'];
  var GIFT_HIGH_USAGE = ['campaigns', 'various_moments'];

  var INDUSTRY_PHRASES = {
    beauty_salon: 'schoonheidssalon',
    lash_brow: 'lash & brow business',
    nails: 'nagelstudio',
    makeup: 'make-up business',
    hair: 'kapperszaak',
    aesthetics: 'aesthetic clinic',
    tattoo: 'tattoo studio',
    dental_beauty: 'dental beauty praktijk',
    pmu: 'PMU-praktijk',
    photographer: 'fotografiebedrijf',
    boutique: 'boutique',
    bridal: 'bridal business',
    wellness: 'wellness- of spa-business',
    other: 'business'
  };

  var USAGE_PHRASES = {
    after_appointment: 'na een behandeling of afspraak',
    new_customers: 'bij nieuwe klanten',
    networking_events: 'tijdens netwerken en events',
    orders_packages: 'bij bestellingen of pakketjes',
    gift: 'als cadeaubon',
    campaigns: 'bij acties of campagnes',
    counter: 'bij de balie of op de werkplek',
    various_moments: 'op verschillende momenten'
  };

  /* 100/250 aanbevolen, 500 nooit aanbevolen (blijft wel beschikbaar als
   * "beste stukprijs"). Zie blueprint-correctie: nooit 500 adviseren. */
  function computeQuantity(productKey, volume, usage) {
    if (productKey === 'gift') {
      return GIFT_HIGH_USAGE.indexOf(usage) !== -1 ? 250 : 100;
    }
    switch (volume) {
      case 'under_10': return 100;
      case '10_20': return HIGH_USAGE.indexOf(usage) !== -1 ? 250 : 100;
      case '20_40': return 250;
      case '40_75': return 250;
      case '75_plus': return 250;
      case 'variable': return HIGH_USAGE.indexOf(usage) !== -1 ? 250 : 100;
      default: return 100;
    }
  }

  function templateKeyFor(productKey, qruse) {
    return productKey === 'qr' ? 'qr_' + qruse : productKey;
  }

  var RESULT_COPY = {
    business: {
      tagline: 'YOUR FIRST IMPRESSION, REFLECTED.',
      setupLines: ['THE BUSINESS CARD'],
      copy: function (industryPhrase, usagePhrase) {
        return 'Voor jouw ' + industryPhrase + ' adviseren we The Business Card. Een clean design met subtiele branding en veel zichtbaar mirror-oppervlak past bij jouw doel: een sterke, persoonlijke indruk achterlaten die klanten onthouden. Gebruik de card bijvoorbeeld ' + usagePhrase + '.';
      }
    },
    qr_booking: {
      tagline: 'FROM MIRROR TO BOOKING — ONE SCAN.',
      setupLines: ['THE QR CARD', 'QR → BOEKINGSPAGINA'],
      copy: function (industryPhrase, usagePhrase) {
        return 'Voor jouw ' + industryPhrase + ' adviseren we The QR Card. Je wilt dat klanten eenvoudig opnieuw kunnen boeken. Laat de QR-code daarom rechtstreeks naar je online boekingspagina leiden. Geef de card mee ' + usagePhrase + ' of gebruik hem als premium touchpoint bij de balie.';
      },
      note: 'Gewenste QR-toepassing: boekingspagina.'
    },
    qr_reviews: {
      tagline: 'SCAN TO REVIEW.',
      setupLines: ['THE QR CARD', 'QR → GOOGLE REVIEWS'],
      copy: function (industryPhrase, usagePhrase) {
        return 'Voor jouw ' + industryPhrase + ' adviseren we The QR Card. Je wilt het voor klanten makkelijker maken om een Google-review achter te laten. Laat de QR-code rechtstreeks naar jouw reviewpagina leiden en gebruik de card bijvoorbeeld ' + usagePhrase + '.';
      },
      note: 'Gewenste QR-toepassing: Google Reviews.'
    },
    qr_instagram: {
      tagline: 'SCAN TO FOLLOW.',
      setupLines: ['THE QR CARD', 'QR → INSTAGRAM'],
      copy: function (industryPhrase, usagePhrase) {
        return 'Jouw werk als ' + industryPhrase + ' is visueel. The QR Card kan rechtstreeks naar je Instagram-profiel leiden, zodat klanten en contacten na één scan meer van je werk zien. Gebruik hem ' + usagePhrase + '.';
      },
      note: 'Gewenste QR-toepassing: Instagram.'
    },
    qr_shop: {
      tagline: 'SCAN TO SHOP.',
      setupLines: ['THE QR CARD', 'QR → WEBSHOP'],
      copy: function (industryPhrase, usagePhrase) {
        return 'Voor jouw ' + industryPhrase + ' adviseren we The QR Card. Laat de QR-code rechtstreeks naar je webshop leiden, zodat klanten direct vanaf de kaart kunnen doorklikken naar je aanbod. Gebruik de card bijvoorbeeld ' + usagePhrase + '.';
      },
      note: 'Gewenste QR-toepassing: webshop.'
    },
    qr_discover: {
      tagline: 'SCAN TO DISCOVER.',
      setupLines: ['THE QR CARD', 'QR → WEBSITE / PORTFOLIO'],
      copy: function (industryPhrase, usagePhrase) {
        return 'Klanten en contacten willen je werk zien. Gebruik The QR Card als opvallende fysieke introductie en laat de QR-code direct naar je website of portfolio leiden. Gebruik hem ' + usagePhrase + '.';
      },
      note: 'Gewenste QR-toepassing: website/portfolio.'
    },
    gift: {
      tagline: 'GIVE SOMETHING WORTH KEEPING.',
      setupLines: ['THE GIFT CARD'],
      copy: function (industryPhrase) {
        return 'Voor jouw ' + industryPhrase + ' adviseren we The Gift Card. De fysieke cadeaubon wordt onderdeel van je merk- en cadeau-ervaring: MIMAH produceert de gepersonaliseerde kaart, jij beheert zelf waarde, geldigheid en inwisseling.';
      }
    },
    loyalty: {
      tagline: 'WORTH COMING BACK FOR.',
      setupLines: ['THE LOYALTY CARD'],
      copy: function () {
        return 'Je wilt vaste klanten belonen en terugkeer onderdeel maken van je klantbeleving. Daarom past The Loyalty Card het beste bij jouw doel.';
      },
      badge: 'COMING SOON'
    }
  };

  var SECONDARY_COPY = {
    business: 'Wil je daarnaast ook een sterke, herkenbare merkbeleving meegeven? Bekijk dan ook The Business Card.',
    qr_booking: 'Wil je klanten ook makkelijker opnieuw laten boeken? Bekijk dan ook The QR Card met een link naar je boekingspagina.',
    qr_reviews: 'Wil je daarnaast ook meer Google-reviews stimuleren? Bekijk dan ook The QR Card met een link naar je reviewpagina.',
    qr_instagram: 'Wil je daarnaast ook meer Instagram-volgers? Bekijk dan ook The QR Card met een link naar je Instagram.',
    gift: 'Wil je jouw aanbod ook als cadeau kunnen aanbieden? Bekijk dan ook The Gift Card.',
    loyalty: 'Wil je klanten ook belonen voor herhaalbezoek? Bekijk dan ook The Loyalty Card.'
  };

  /* ---------------------------------------------------------------------
   * State
   * ------------------------------------------------------------------- */
  var state = { step: -1, answers: {} };

  var screens = {
    intro: root.querySelector('[data-screen="intro"]'),
    question: root.querySelector('[data-screen="question"]'),
    result: root.querySelector('[data-screen="result"]')
  };
  var backBtn = root.querySelector('[data-mirror-finder-back]');
  var progressWrap = root.querySelector('[data-mirror-finder-progress]');
  var progressFill = root.querySelector('[data-progress-fill]');
  var progressLabel = root.querySelector('[data-progress-label]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showScreen(name) {
    Object.keys(screens).forEach(function (key) {
      if (screens[key]) screens[key].hidden = key !== name;
    });
  }

  root.querySelector('[data-mirror-finder-start]').addEventListener('click', function () {
    state.step = 0;
    state.answers = {};
    renderQuestion();
  });

  backBtn.addEventListener('click', function () {
    if (state.step <= 0) {
      state.step = -1;
      backBtn.hidden = true;
      progressWrap.hidden = true;
      showScreen('intro');
      return;
    }
    state.step -= 1;
    renderQuestion();
  });

  root.querySelector('[data-mirror-finder-restart]').addEventListener('click', function () {
    state.step = -1;
    state.answers = {};
    backBtn.hidden = true;
    progressWrap.hidden = true;
    showScreen('intro');
  });

  function renderQuestion() {
    var q = QUESTIONS[state.step];
    showScreen('question');
    backBtn.hidden = false;
    progressWrap.hidden = false;
    progressFill.style.width = (((state.step + 1) / QUESTIONS.length) * 100) + '%';
    progressLabel.textContent = ('0' + (state.step + 1)).slice(-2) + ' / 0' + QUESTIONS.length;

    screens.question.querySelector('[data-question-eyebrow]').textContent = q.eyebrow;
    screens.question.querySelector('[data-question-title]').textContent = q.title;
    var supportEl = screens.question.querySelector('[data-question-support]');
    supportEl.textContent = q.support || '';
    supportEl.hidden = !q.support;

    var optionsEl = screens.question.querySelector('[data-question-options]');
    optionsEl.innerHTML = '';
    var otherWrap = screens.question.querySelector('[data-question-other]');
    otherWrap.hidden = true;

    q.options.forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mirror-finder__option';
      btn.textContent = opt.label;
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', state.answers[q.id] === opt.value ? 'true' : 'false');
      if (state.answers[q.id] === opt.value) btn.classList.add('is-selected');
      btn.addEventListener('click', function () {
        state.answers[q.id] = opt.value;
        if (q.allowOther && opt.value === 'other') {
          otherWrap.hidden = false;
          var input = otherWrap.querySelector('[data-question-other-input]');
          input.value = state.answers.industry_other || '';
          input.focus();
          return;
        }
        advance();
      });
      optionsEl.appendChild(btn);
    });

    otherWrap.querySelector('[data-question-other-continue]').onclick = function () {
      state.answers.industry_other = otherWrap.querySelector('[data-question-other-input]').value.trim();
      advance();
    };
  }

  function advance() {
    var delay = reduceMotion ? 0 : 220;
    setTimeout(function () {
      if (state.step >= QUESTIONS.length - 1) {
        renderResult();
      } else {
        state.step += 1;
        renderQuestion();
      }
    }, delay);
  }

  function buildProductUrl(productKey, quantity, note) {
    var product = PRODUCTS[productKey];
    var variantId = product.variants[quantity];
    var url = '/products/' + product.handle + '?variant=' + variantId;
    if (note) url += '&finder_note=' + encodeURIComponent(note);
    return url;
  }

  function computeResult() {
    var a = state.answers;
    var primary = ACTION_MAP[a.action] || { product: 'business' };
    var productKey = primary.product;
    var qruse = primary.qruse;
    if (productKey === 'qr' && !qruse) {
      qruse = SHOP_INDUSTRIES.indexOf(a.industry) !== -1 ? 'shop' : 'discover';
    }
    var templateKey = templateKeyFor(productKey, qruse);
    var quantity = computeQuantity(productKey, a.volume, a.usage);

    var goalImplied = GOAL_MAP[a.goal];
    var secondaryKey = null;
    if (goalImplied) {
      var goalTemplateKey = templateKeyFor(goalImplied.product, goalImplied.qruse);
      if (goalTemplateKey !== templateKey) secondaryKey = templateKeyFor(goalImplied.product, goalImplied.qruse);
    }

    var industryPhrase = a.industry === 'other' && a.industry_other ? a.industry_other : (INDUSTRY_PHRASES[a.industry] || 'business');
    var usagePhrase = USAGE_PHRASES[a.usage] || 'op de momenten die bij jou passen';

    return {
      productKey: productKey,
      qruse: qruse,
      templateKey: templateKey,
      quantity: quantity,
      industryPhrase: industryPhrase,
      usagePhrase: usagePhrase,
      secondaryKey: secondaryKey,
      secondaryProductKey: goalImplied ? goalImplied.product : null
    };
  }

  function qtyNote(quantity) {
    if (quantity === 100) return 'Op basis van je antwoorden lijkt 100 stuks een logische, laagdrempelige start.';
    return 'Op basis van je antwoorden lijkt 250 stuks een sterke start voor jouw business.';
  }

  function renderResult() {
    var result = computeResult();
    var chosenQuantity = result.quantity;
    var product = PRODUCTS[result.productKey];
    var copy = RESULT_COPY[result.templateKey] || RESULT_COPY.business;

    showScreen('result');
    backBtn.hidden = false;
    progressWrap.hidden = true;

    screens.result.querySelector('[data-result-product]').textContent = product.name;
    screens.result.querySelector('[data-result-tagline]').textContent = copy.tagline;
    var badgeEl = screens.result.querySelector('[data-result-badge]');
    if (copy.badge) { badgeEl.textContent = copy.badge; badgeEl.hidden = false; } else { badgeEl.hidden = true; }
    screens.result.querySelector('[data-result-copy]').textContent = copy.copy(result.industryPhrase, result.usagePhrase);

    var setup1 = screens.result.querySelector('[data-setup-line-1]');
    var setup2 = screens.result.querySelector('[data-setup-line-2]');
    setup1.textContent = copy.setupLines[0] || '';
    if (copy.setupLines[1]) { setup2.textContent = copy.setupLines[1]; setup2.hidden = false; } else { setup2.hidden = true; }

    var qtyButtons = screens.result.querySelectorAll('[data-qty]');
    function paintQuantity() {
      qtyButtons.forEach(function (btn) {
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        var badge = btn.querySelector('[data-qty-badge]');
        var isSelected = qty === chosenQuantity;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        if (qty === result.quantity) {
          badge.textContent = 'AANBEVOLEN VOOR JOU';
        } else if (qty === 500) {
          badge.textContent = 'BESTE STUKSPRIJS';
        } else if (qty === 100) {
          badge.textContent = 'START';
        } else {
          badge.textContent = '';
        }
      });
      screens.result.querySelector('[data-qty-note]').textContent = qtyNote(result.quantity);
      updateCta();
    }
    qtyButtons.forEach(function (btn) {
      btn.onclick = function () {
        chosenQuantity = parseInt(btn.getAttribute('data-qty'), 10);
        paintQuantity();
      };
    });
    paintQuantity();

    var secondaryWrap = screens.result.querySelector('[data-secondary]');
    if (result.secondaryKey && SECONDARY_COPY[result.secondaryKey]) {
      secondaryWrap.hidden = false;
      screens.result.querySelector('[data-secondary-copy]').textContent = SECONDARY_COPY[result.secondaryKey];
      var secLink = screens.result.querySelector('[data-secondary-link]');
      var secProduct = PRODUCTS[result.secondaryProductKey];
      secLink.textContent = 'BEKIJK ' + secProduct.name;
      secLink.href = buildProductUrl(result.secondaryProductKey, 100, null);
    } else {
      secondaryWrap.hidden = true;
    }

    var ctaEl = screens.result.querySelector('[data-result-cta]');
    function updateCta() {
      ctaEl.textContent = product.launched ? product.ctaLaunched : product.ctaPrelaunch;
      ctaEl.href = buildProductUrl(result.productKey, chosenQuantity, copy.note || null);
    }
    updateCta();
  }
});
